module.exports = __webpack_public_path__ + "img/caixa.cc9f883b.svg";